export default __webpack_public_path__ + "static/media/standsExpo_revistacaname.73fd2017.jpg";